import React, { useState, useEffect } from 'react';
import { Button, Input, Card } from '../components';
import { authService, api } from '../services';
import '../styles/AddUser.scss';

const AddUser = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    role: 'Finance',
    company_id: '',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    api.get('/core/companies/')
    .then(res => setCompanies(res.data.filter(c => !c.archived)))
    .catch(() => {});
  }, []); //empty array ensures it only runs once on mount

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
    setSuccessMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSuccessMessage('');
    setIsLoading(true);
    try {
      const response = await authService.createUser(formData);
      setSuccessMessage(`User "${formData.username}" created. Temporary password: ${response.password}`);
      setFormData({
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        role: 'Finance',
        company_id: '',
      });
    } catch (error) {
      if (error.response?.data) {
        setErrors(error.response.data);
      } else {
        setErrors({ general: 'Failed to create user. Please try again.' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-user-container">
      <Card title="Add New User" className="add-user-card">
        <form onSubmit={handleSubmit}>
          {errors.general && <div className="error-banner">{errors.general}</div>}
          {successMessage && <div className="success-banner">{successMessage}</div>}
          <div className="add-user-grid">
            <Input
              label="First Name"
              type="text"
              name="first_name"
              placeholder="Enter first name"
              value={formData.first_name}
              onChange={handleChange}
              error={errors.first_name}
            />
            <Input
              label="Last Name"
              type="text"
              name="last_name"
              placeholder="Enter last name"
              value={formData.last_name}
              onChange={handleChange}
              error={errors.last_name}
            />
          </div>
          <Input
            label="Username"
            type="text"
            name="username"
            placeholder="Choose a username"
            value={formData.username}
            onChange={handleChange}
            error={errors.username}
            required
          />
          <Input
            label="Email"
            type="email"
            name="email"
            placeholder="Enter email address"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
            required
          />
          <div className="add-user-field">
            <label className="input-label">Company</label>
            <select
              name="company_id"
              value={formData.company_id}
              onChange={handleChange}
              className="ci-select"
              required
            >
              <option value="">-- Select a company --</option>
              {companies.map(company => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>
            {errors.company_id && <span className="input-error">{errors.company_id}</span>}
          </div>

          <div className="add-user-field">
            <label className="input-label">Role</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="ci-select"
            >
              <option value="Consultant">Consultant</option>
              <option value="BEE Manager">BEE Manager</option>
              <option value="Finance">Finance</option>
              <option value="HR">HR</option>
              <option value="Logistics">Logistics</option>
            </select>
          </div>
          <Button type="submit" fullWidth disabled={isLoading}>
            {isLoading ? 'Creating User...' : 'Create User'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default AddUser;
